import CellTowerIcon from '../components/Icons/CellTowerIcon';
import WiFiIcon from '../components/Icons/WiFiIcon';
import connectionTypes from '../consts/connectionTypes';
import deviceTypes from '../consts/device/deviceTypes';
import routes from '../consts/routes';
import {strCode} from '../consts/strCode';
import configCustomFeaturesGetters from './getters/configCustomFeaturesGetters';

const selectDeviceConfig = [
    {
        deviceType: deviceTypes.ILUMA_I5_CHARGER,
        buttonStrCode: strCode.SELECT_DEVICE_ILUMA_I5_WIFI_BUTTON,
        connectionType: connectionTypes.WIFI,
        icon: WiFiIcon,
    },
    {
        deviceType: deviceTypes.ILUMA_I2_CHARGER,
        buttonStrCode: strCode.SELECT_DEVICE_ILUMA_I2_WIFI_BUTTON,
        connectionType: connectionTypes.WIFI,
        icon: WiFiIcon,
    },
    {
        deviceType: deviceTypes.ILUMA_I2_CHARGER,
        buttonStrCode: strCode.SELECT_DEVICE_ILUMA_I2_LTE_BUTTON,
        connectionType: connectionTypes.CELLULAR,
        icon: CellTowerIcon,
    },
    {
        deviceType: deviceTypes.ILUMA_I5_CHARGER,
        buttonStrCode: strCode.SELECT_DEVICE_ILUMA_I5_SIDEWALK_BUTTON,
        connectionType: connectionTypes.SIDEWALK,
        icon: WiFiIcon,
        navigateTo: routes.SIDEWALK_CONNECTION_GUIDE_INTRO,
    },
];

export const getSortedSelectDeviceConfig = () => {
    const defaultDeviceType = configCustomFeaturesGetters.getDefaultDeviceType();

    // Sort items with default device type come first
    return [...selectDeviceConfig].sort(
        (a, b) => (b.deviceType === defaultDeviceType) - (a.deviceType === defaultDeviceType)
    );
};

export default selectDeviceConfig;
